// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { useState, useEffect } from 'react';
import Particles, { ParticlesProvider } from '@tsparticles/react';
import { loadConfettiPreset } from '@tsparticles/preset-confetti';
import { Overlay } from '@plesk/ui-library';
import Lottie from 'lottie-react-web';
import { UAT } from 'jsw';

// Easter egg "Disco Mode" — Plesk 70s anniversary (Plesk 18.0.70). Safe to drop with the egg.


const secret = 'DISCO';

const DiscoMode = () => {
    const [, setBuffer] = useState('');
    const [isOpen, setOpen] = useState(false);
    const [discoBall, setDiscoBal] = useState(false);
    const [confettiTop, setConfettiTop] = useState(false);
    const [confettiBottom, setConfettiBottom] = useState(false);
    const [confettiMax, setConfettiMax] = useState(false);

    useEffect(() => {
        const handleKeyDown = e => {
            setBuffer(buffer => {
                const newBuffer = (buffer + e.key).slice(-secret.length);
                if (newBuffer === secret) {
                    handleDiscoMode();
                    return '';
                }
                return newBuffer;
            });
        };

        document.addEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        if (isOpen && !discoBall) {
            import(/* webpackChunkName: "components/layouts/page-layout/disco-ball" */ './disco-ball.json').then(setDiscoBal);
        }
    }, [isOpen, discoBall]);

    const handleDiscoMode = () => {
        UAT.dispatchAction('PLESK-70-DISCO');

        setConfettiTop(false);
        setConfettiBottom(false);
        setConfettiMax(false);
        setOpen(true);

        setTimeout(() => {
            setConfettiTop(true);
        }, 500);
        setTimeout(() => {
            setConfettiBottom(true);
        }, 2000);
        setTimeout(() => {
            setConfettiMax(true);
        }, 6000);

        setTimeout(() => {
            setOpen(false);
        }, 10000);
    };

    return (
        <Overlay
            isOpen={isOpen}
            className="disco-mode"
        >
            {isOpen ? (
                <ParticlesProvider
                    init={async engine => {
                        await loadConfettiPreset(engine);
                        engine.pluginManager.addPalette('disco-confetti-top', {
                            name: 'disco-confetti-top',
                            colors: { fill: { enable: true, value: ['#fff', '#af9aff', '#6a9fff', '#99dff6', '#315080'] } },
                        });
                        engine.pluginManager.addPalette('disco-confetti-bottom', {
                            name: 'disco-confetti-bottom',
                            colors: { fill: { enable: true, value: ['#e1761e', '#428b8c', '#cf4e29', '#41919d', '#e8af28'] } },
                        });
                    }}
                >
                    <div className="disco-mode-logo disco-mode-showup">
                        <img src={require('images/disco-mode/logo.svg')} alt="plesk-70" />
                    </div>
                    {discoBall && (
                        <div className="disco-mode-ball">
                            <Lottie options={{ animationData: discoBall }} />
                        </div>
                    )}
                    <div className="disco-mode-dancers disco-mode-showup">
                        <img src={require('images/disco-mode/dancers.gif')} alt="dancers" />
                    </div>
                    {confettiTop && !confettiBottom && (
                        <Particles
                            id="disco-mode-confetti-top"
                            className="disco-mode-confetti"
                            options={{
                                palette: 'disco-confetti-top',
                                emitters: [
                                    {
                                        position: { x: 50, y: 20 },
                                        rate: { quantity: 300, delay: 5 },
                                    },
                                ],
                                preset: 'confetti',
                            }}
                        />
                    )}
                    {confettiBottom && (
                        <Particles
                            id="disco-mode-confetti-bottom"
                            className="disco-mode-confetti"
                            options={{
                                palette: 'disco-confetti-bottom',
                                emitters: [
                                    {
                                        position: { x: 5, y: 50 },
                                        direction: 'top-right',
                                        rate: { quantity: 250, delay: 1 },
                                    },
                                    {
                                        position: { x: 95, y: 50 },
                                        direction: 'top-left',
                                        rate: { quantity: 250, delay: 1 },
                                    },
                                ],
                                preset: 'confetti',
                            }}
                        />
                    )}
                    {confettiMax && (
                        <Particles
                            id="disco-mode-confetti-bottom-max"
                            className="disco-mode-confetti"
                            options={{
                                palette: 'disco-confetti-bottom',
                                emitters: [
                                    {
                                        position: { x: 5, y: 50 },
                                        direction: 'top-right',
                                        rate: { quantity: 100 },
                                    },
                                    {
                                        position: { x: 95, y: 50 },
                                        direction: 'top-left',
                                        rate: { quantity: 100 },
                                    },
                                ],
                                preset: 'confetti',
                            }}
                        />
                    )}
                </ParticlesProvider>
            ) : null}
        </Overlay>
    );
};

export default DiscoMode;

